// Persian UI strings, keyed by the English text passed to t() in the components.
const fa = {
  // Brand and navigation
  "Pocket Play": "پاکت پلی",
  "Pocket Play home": "صفحه اصلی پاکت پلی",
  "Play together": "بازی های دورهمی با دوستان و خانواده",
  "Games": "بازی‌ها",
  "Tournaments": "تورنمنت ها",
  "Plans": "پلن‌ها",
  "About": "درباره",
  "Terms": "قوانین و مقررات",
  "Account": "حساب کاربری",
  "View account": "مشاهده اکانت",
  "Player": "بازیکن",
  "Player {{id}}": "بازیکن {{id}}",
  "Log in": "ورود",
  "Log out": "خروج",
  "Logging out": "در حال خروج",
  "Logging out...": "در حال خروج...",
  "Sign up": "ثبت‌نام",
  "Main navigation": "منوی اصلی",
  "Mobile navigation": "منوی موبایل",
  "Open navigation": "باز کردن منو",
  "Close navigation": "بستن منو",
  "Loading": "در حال بارگذاری",
  "Loading...": "در حال بارگذاری...",
  "Loading…": "در حال بارگذاری…",
  "Big-screen party games where every phone becomes a controller.": "بازی‌های گروهی روی اسکرین بزرگ، با گوشی‌هایی که دسته بازی می‌شوند.",

  // Home
  "Colorful gaming illustration": "تصویر رنگارنگ بازی",
  "Games for EVERYONE!": "بازی برای همه!",
  "Use your phone as a controller! No downloads, no hassle. Just instant fun with your friends!": "گوشی‌تان را دسته بازی کنید! بدون دانلود و بدون دردسر؛ سرگرمی فوری با دوستان!",
  "Active gaming experience": "تجربه بازی پرتحرک",
  "Move, Play, Compete!": "حرکت کن، بازی کن، رقابت کن!",
  "Use your phone as a kinect! Jump, walk, and compete in a variety of fun and active games!": "گوشی‌تان را مثل کینکت به کار بگیرید! در انواع بازی‌های پرتحرک و سرگرم‌کننده رقابت کنید!",
  "Show slide {{number}}": "نمایش اسلاید {{number}}",

  // Game library
  "Search games": "جست‌وجوی بازی‌ها",
  "Open filters": "باز کردن فیلترها",
  "Close filters": "بستن فیلترها",
  "Clear all filters": "پاک کردن همه فیلترها",
  "Open sorting": "باز کردن مرتب‌سازی",
  "Close sorting": "بستن مرتب‌سازی",
  "Clear sorting": "پاک کردن مرتب‌سازی",
  "Refine your games": "بازی‌ها را دقیق‌تر پیدا کنید",
  "Results update as you choose": "نتایج با هر انتخاب به‌روز می‌شوند",
  "{{count}} active": "{{count}} فعال",
  "Motion games": "بازی‌های حرکتی",
  "Play using body movement": "بازی با حرکت بدن",
  "Playable for me": "بازی های من",
  "Games you can launch now": "بازی‌هایی که همین حالا می‌توانید اجرا کنید",
  "Competition type": "نوع رقابت",
  "Competition": "رقابت",
  "Competitive": "رقابتی",
  "Cooperative": "همکاری",
  "Coop": "همکاری",
  "Co-op": "همکاری",
  "Mixed": "ترکیبی",
  "Co-op & Comp": "همکاری و رقابت",
  "Face off": "رودررو",
  "Team up": "هم‌تیمی",
  "Both styles": "هر دو سبک",
  "Difficulty": "سختی",
  "Easy": "آسان",
  "Medium": "متوسط",
  "Hard": "سخت",
  "Expert": "حرفه‌ای",
  "Playtime": "مدت بازی",
  "Players": "بازیکنان",
  " min": " دقیقه",
  "{{label}} minimum": "حداقل {{label}}",
  "{{label}} maximum": "حداکثر {{label}}",
  "Genres": "ژانرها",
  "Tags": "برچسب‌ها",
  "Action, Puzzle": "اکشن، پازل",
  "Family, Party": "خانوادگی، مهمانی",
  "Clear filters": "پاک کردن فیلترها",
  "Sort games": "مرتب‌سازی بازی‌ها",
  "Choose how results are ordered": "ترتیب نمایش نتایج را انتخاب کنید",
  "Current order:": "ترتیب فعلی:",
  "Default": "پیش‌فرض",
  "Featured": "پیشنهادی",
  "Our default game order": "ترتیب پیش‌فرض ما",
  "Price: Low to high": "قیمت: کم به زیاد",
  "Lowest price first": "ارزان‌ترین‌ها اول",
  "Price: High to low": "قیمت: زیاد به کم",
  "Highest price first": "گران‌ترین‌ها اول",
  "Quickest games": "کوتاه‌ترین بازی‌ها",
  "Shortest playtime first": "کوتاه‌ترین مدت بازی اول",
  "Longest games": "طولانی‌ترین بازی‌ها",
  "Longest playtime first": "طولانی‌ترین مدت بازی اول",
  "Top rated": "محبوب‌ترین",
  "Highest player rating": "بالاترین امتیاز بازیکنان",
  "Most reviewed": "پرنظرترین",
  "Most community reviews": "بیشترین نظر کاربران",
  "No games found.": "بازی‌ای پیدا نشد.",
  "Error: {{message}}": "خطا: {{message}}",
  "Games pages": "صفحه‌های بازی‌ها",
  "Go to page {{page}}": "رفتن به صفحه {{page}}",
  "Buy {{game}}": "خرید {{game}}",
  "game": "بازی",
  "{{title}} preview": "پیش‌نمایش {{title}}",
  "~{{minutes}} min": "حدود {{minutes}} دقیقه",
  "~{{minutes}} minutes": "حدود {{minutes}} دقیقه",
  "Browse the game library": "مرور کتابخانه بازی‌ها",
  "Previous slide": "اسلاید قبلی",
  "Next slide": "اسلاید بعدی",
  "Games ({{count}})": "بازی‌ها ({{count}})",
  "Previous game": "بازی قبلی",
  "Next game": "بازی بعدی",
  "Open details": "نمایش جزئیات",
  "Close details": "بستن جزئیات",
  "Previous page": "صفحه قبلی",
  "Next page": "صفحه بعدی",
  "Game details": "جزئیات بازی",
  "Previous media": "تصویر قبلی",
  "Next media": "تصویر بعدی",
  "Play game": "اجرای بازی",
  "Search and sort": "جست‌وجو و مرتب‌سازی",
  "Game title": "نام بازی",
  "Sort": "مرتب‌سازی",
  "Filters": "فیلترها",
  "Minimum playtime": "حداقل مدت بازی",
  "Maximum playtime": "حداکثر مدت بازی",
  "Minimum players": "حداقل بازیکن",
  "Maximum players": "حداکثر بازیکن",

  // Game details and purchase
  "Loading media...": "در حال بارگذاری تصاویر...",
  "Loading description...": "در حال بارگذاری توضیحات...",
  "No description available for this game yet.": "هنوز توضیحی برای این بازی ثبت نشده است.",
  "Previous": "قبلی",
  "Next": "بعدی",
  "Close": "بستن",
  "Play": "بازی کن",
  "Subscribe": "خرید اشتراک",
  "Buy": "خرید",
  "Buy ({{price}})": "خرید ({{price}})",
  "Admin activation": "فعال‌سازی توسط مدیر",
  "Admin activation required": "نیاز به فعال‌سازی توسط مدیر",
  "Opening...": "در حال باز کردن...",
  "Buy this game once and keep it forever, or subscribe monthly to unlock the full games library.": "این بازی را یک‌بار بخرید و برای همیشه داشته باشید، یا با اشتراک ماهانه به همه بازی‌ها دسترسی پیدا کنید.",
  "Online checkout is disabled during the beta. View the plans and ask an administrator to activate access.": "پرداخت آنلاین در دوره آزمایشی غیرفعال است. پلن‌ها را ببینید و برای فعال‌سازی دسترسی با مدیر تماس بگیرید.",
  "Could not start checkout.": "شروع پرداخت ممکن نشد.",

  // Checkout details
  "We send renewal reminders to this mobile number.": "یادآور تمدید را به این شماره موبایل می‌فرستیم.",
  "Mobile number": "شماره موبایل",
  "Discount or referral code (optional)": "کد تخفیف یا کد دعوت (اختیاری)",
  "Continue to payment": "ادامه و پرداخت",
  "Cancel": "انصراف",

  // Plans
  "Toman": "تومان",
  "month": "ماه",
  "year": "سال",
  "Monthly": "ماهانه",
  "Yearly": "سالانه",
  "Active": "فعال",
  "Scheduled": "زمان‌بندی‌شده",
  "Acquired": "خریداری‌شده",
  "Upgrade": "ارتقا",
  "Downgrade": "تغییر به پلن پایین‌تر",
  "Upgrade to Yearly": "ارتقا به سالانه",
  "Downgrade to Monthly": "تغییر به ماهانه",
  "Change Plan": "تغییر پلن",
  "{{count}} active session": "{{count}} نشست هم‌زمان",
  "{{count}} active sessions": "{{count}} نشست هم‌زمان",
  "Full access to all current and future games": "دسترسی کامل به همه بازی‌های فعلی و آینده",
  "Subscribe to {{plan}}": "خرید اشتراک {{plan}}",
  "{{count}} hours": "{{count}} ساعت",
  "Full access to all games": "دسترسی کامل به همه بازی‌ها",
  "Most popular": "محبوب‌ترین",
  "Duration": "مدت",
  "Renewal": "تمدید",
  "One-time payment": "پرداخت یک‌باره",
  "Get {{count}}-Hour Access": "دسترسی {{count}} ساعته",
  "Choose {{plan}}": "انتخاب {{plan}}",
  "Included in your plan": "در اشتراک شما موجود است",
  "Add {{count}} Hours": "افزودن {{count}} ساعت",
  "Buy {{plan}}": "خرید {{plan}}",
  "One-time pass": "پاس یک‌باره",
  "See plans": "مشاهده پلن‌ها",
  "Membership plans": "پلن‌های اشتراک",
  "Membership": "اشتراک",
  "Choose your play pass": "پلن بازی‌تان را انتخاب کنید",
  "Pick a plan for the games, players, and sessions that fit your setup.": "پلنی که با تعداد بازی های همزمان شما جور است را انتخاب کنید.",
  "Online payments are disabled during the beta. Ask an administrator to activate the plan you need.": "پرداخت آنلاین در دوره آزمایشی غیرفعال است. برای فعال‌سازی پلن موردنظر با مدیر تماس بگیرید.",
  "Checkout was cancelled. You can choose a plan whenever you are ready.": "پرداخت لغو شد. هر وقت آماده بودید می‌توانید پلن را انتخاب کنید.",
  "Your subscription change is scheduled for the end of the current billing period.": "تغییر اشتراک شما برای پایان دوره فعلی زمان‌بندی شد.",
  "Could not schedule subscription change.": "زمان‌بندی تغییر اشتراک ممکن نشد.",
  "Phone requested {{plan}}": "درخواست {{plan}} از گوشی",
  "Confirm on this screen before opening checkout or scheduling a subscription change.": "پیش از رفتن به پرداخت یا زمان‌بندی تغییر اشتراک، روی همین صفحه تأیید کنید.",
  "Confirm": "تأیید",
  "Loading subscription plans...": "در حال بارگذاری پلن‌ها...",
  "Could not load subscription plans.": "بارگذاری پلن‌ها ممکن نشد.",
  "Scheduling...": "در حال زمان‌بندی...",
  "Billing": "دوره پرداخت",
  "Previous plan": "پلن قبلی",
  "Next plan": "پلن بعدی",
  "Choose on main screen": "انتخاب روی صفحه اصلی",

  // Account
  "No expiry": "بدون انقضا",
  "Unknown": "نامشخص",
  "Trialing": "آزمایشی",
  "Past due": "سررسید گذشته",
  "Unpaid": "پرداخت‌نشده",
  "Canceled": "لغوشده",
  "Not recorded": "ثبت نشده",
  "Yearly Upgrade Scheduled": "ارتقای سالانه زمان‌بندی شد",
  "{{plan}} Upgrade Scheduled": "ارتقا به {{plan}} زمان‌بندی شد",
  "Upgrade to {{plan}}": "ارتقا به {{plan}}",
  "Subscription plan": "پلن اشتراک",
  "Active subscription": "اشتراک فعال",
  "Previous subscription": "اشتراک قبلی",
  "Subscription": "اشتراک",
  "Cancellation is scheduled. You keep access until {{date}}.": "لغو اشتراک زمان‌بندی شده است. تا {{date}} دسترسی دارید.",
  "{{plan}} ({{interval}}) is scheduled from {{date}}. Renewals are billed for this plan.": "{{plan}} ({{interval}}) از {{date}} فعال می‌شود. تمدیدها با همین پلن محاسبه می‌شوند.",
  "Started": "شروع",
  "Ends": "پایان",
  "Sessions": "نشست‌ها",
  "Renew": "تمدید",
  "Cancellation Scheduled": "لغو زمان‌بندی شد",
  "Cancel Subscription": "لغو اشتراک",
  "Online billing changes are disabled during the beta. Ask an administrator to update this subscription.": "تغییرات آنلاین اشتراک در دوره آزمایشی غیرفعال است. برای به‌روزرسانی با مدیر تماس بگیرید.",
  "Owned game": "بازی خریداری‌شده",
  "Subscriptions, owned games, and play history": "اشتراک‌ها، بازی‌های خریداری‌شده و سابقه بازی",
  "Sign in to view your account": "برای دیدن حساب وارد شوید",
  "Account sections": "بخش‌های حساب",
  "Active plan": "پلن فعال",
  "Previous plans": "پلن‌های قبلی",
  "Owned games": "بازی‌های خریداری‌شده",
  "Play history": "سابقه بازی",
  "View plans": "مشاهده پلن‌ها",
  "Cancel your active subscription at the end of the current billing period?": "اشتراک فعال شما در پایان دوره فعلی لغو شود؟",
  "Renew subscription": "تمدید اشتراک",
  "Loading account...": "در حال بارگذاری حساب...",
  "Sign in to see your subscriptions, games, and play history.": "برای دیدن اشتراک‌ها، بازی‌ها و سابقه بازی‌تان وارد شوید.",
  "Your Pocket Play": "پاکت پلی شما",
  "Loading subscriptions...": "در حال بارگذاری اشتراک‌ها...",
  "Your subscription has been renewed.": "اشتراک شما تمدید شد.",
  "Could not start the renewal payment.": "شروع پرداخت تمدید ممکن نشد.",
  "Your subscription upgrade is scheduled for the end of the current billing period.": "ارتقای اشتراک شما برای پایان دوره فعلی زمان‌بندی شد.",
  "Could not schedule subscription upgrade.": "زمان‌بندی ارتقای اشتراک ممکن نشد.",
  "Could not cancel subscription.": "لغو اشتراک ممکن نشد.",
  "No active subscription": "اشتراک فعالی ندارید",
  "Subscribe to unlock the games library.": "برای باز شدن همه بازی‌ها اشتراک بخرید.",
  "Previous subscriptions": "اشتراک‌های قبلی",
  "{{count}} total": "{{count}} مورد",
  "No previous subscriptions yet.": "هنوز اشتراک قبلی ندارید.",
  "Loading owned games...": "در حال بارگذاری بازی‌های خریداری‌شده...",
  "You have not bought any games yet.": "هنوز بازی‌ای نخریده‌اید.",
  "Playtime history": "سابقه بازی",
  "Sessions, rounds, scores, and winners.": "نشست‌ها، دورها، امتیازها و برندگان.",

  // Play history
  "{{hours}}h {{minutes}}m": "{{hours}} ساعت و {{minutes}} دقیقه",
  "{{minutes}} min": "{{minutes}} دقیقه",
  "{{seconds}} sec": "{{seconds}} ثانیه",
  "Less than a minute": "کمتر از یک دقیقه",
  "Unknown date": "تاریخ نامشخص",
  ", ": "، ",
  "Winners: {{names}}": "برندگان: {{names}}",
  "Winner: {{name}}": "برنده: {{name}}",
  "Round finished": "دور تمام شد",
  "Round in progress": "دور در جریان است",
  "Round {{number}}": "دور {{number}}",
  "Winner": "برنده",
  "No player scores were recorded for this round.": "امتیازی برای این دور ثبت نشد.",
  "Game session": "نشست بازی",
  "Finished": "تمام‌شده",
  "{{count}} round": "{{count}} دور",
  "{{count}} rounds": "{{count}} دور",
  "{{count}} game": "{{count}} بازی",
  "{{count}} games": "{{count}} بازی",
  "Tournament": "مسابقه",
  "Lobby": "لابی",
  "Playing": "در حال بازی",
  "Cancelled": "لغوشده",
  "Overall winners": "برندگان نهایی",
  "Overall winner": "برنده نهایی",
  "Tournament run": "اجرای مسابقه",
  "{{mode}} scoring": "امتیازدهی {{mode}}",
  "Games in tournament": "بازی‌های مسابقه",
  "Overall standings": "جدول نهایی",
  "Played games and rounds": "بازی‌ها و دورهای انجام‌شده",
  "Game {{number}}: {{title}}": "بازی {{number}}: {{title}}",
  "Game": "بازی",
  "Attempt {{number}}": "تلاش {{number}}",
  "Loading play history...": "در حال بارگذاری سابقه بازی...",
  "Could not load your play history.": "بارگذاری سابقه بازی ممکن نشد.",
  "Your completed game sessions will appear here.": "بازی‌های تمام‌شده شما اینجا نمایش داده می‌شوند.",

  // Auth
  "Continue your streak": "ادامه‌اش بدهید",
  "Your next game night is one sign-in away.": "یک ورود تا فان!",
  "Pick up where you left off, invite the room, and turn every phone into a controller.": "بازی های خود را ادامه دهید، تورنمنت برگزار کنید، جمع را دعوت کنید و هر گوشی را به دسته بازی تبدیل کنید.",
  "Lobby ready": "لابی آماده است",
  "Join Pocket Play": "به پاکت پلی بپیوندید",
  "Make the room your arcade.": "اتاق‌تان را به گیم‌نت تبدیل کنید.",
  "Create a player profile to collect games, host tournaments, and keep every win on the board.": "یک پروفایل بسازید تا بازی‌هایتان را ذخیره کنید، تورنمنت برگزار کنید و سابقه بُردهایتان ثبت شود.",
  "New player slot": "جای بازیکن جدید",
  "No controller needed": "بدون نیاز به دسته",
  "Instant multiplayer": "چندنفره در یک لحظه",
  "Play anywhere": "بازی در هر جا",
  "Room code": "کد اتاق",
  "Pocket Play benefits": "مزایای پاکت پلی",
  "Sign in": "ورود",
  "Create account": "ساخت حساب",
  "Enter credentials securely on the main screen": "اطلاعات ورود را روی صفحه اصلی وارد کنید",
  "Unable to sign in. Check your email, username, and password.": "ورود ممکن نشد. ایمیل، نام کاربری و رمز عبور را بررسی کنید.",
  "Unable to sign in. Check your email, phone, username, and password.": "ورود ممکن نشد. ایمیل، شماره موبایل، نام کاربری و رمز عبور را بررسی کنید.",
  "Session active": "نشست فعال",
  "You're already in.": "شما وارد شده‌اید.",
  "Signed in as": "واردشده با",
  "Browse games": "مشاهده بازی‌ها",
  "Welcome back, player": "خوش برگشتی",
  "Ready for another round?": "برای یک دست دیگر آماده‌اید؟",
  "Sign in to access your games, tournaments, and play history.": "وارد شوید تا به بازی‌ها، تورنمنت ها و سابقه بازی‌تان دسترسی داشته باشید.",
  "Email or username": "ایمیل یا نام کاربری",
  "Email, phone, or username": "ایمیل، شماره موبایل یا نام کاربری",
  "Password": "رمز عبور",
  "Enter your password": "رمز عبور را وارد کنید",
  "Show password": "نمایش رمز عبور",
  "Hide password": "پنهان کردن رمز عبور",
  "Opening your lobby...": "در حال باز کردن لابی...",
  "Enter Pocket Play": "ورود به پاکت پلی",
  "New to the game?": "تازه آمده‌اید؟",
  "Create your player profile": "پروفایل جدید بسازید",
  "We couldn't create your account. Please try again.": "ساخت حساب ممکن نشد. لطفاً دوباره تلاش کنید.",
  "We couldn't create your account. Please check your details.": "ساخت حساب ممکن نشد. لطفاً اطلاعات را بررسی کنید.",
  "Enter account details securely on the main screen": "اطلاعات حساب را روی صفحه اصلی وارد کنید",
  "Those passwords don't match yet. Check them and try again.": "رمزهای عبور یکسان نیستند. بررسی کنید و دوباره تلاش کنید.",
  "Show passwords": "نمایش رمزهای عبور",
  "Hide passwords": "پنهان کردن رمزهای عبور",
  "Player one, step in": "بازیکن اول، بفرمایید",
  "Create your player profile.": "پروفایل‌تان را بسازید.",
  "One account keeps your games, wins, and tournament nights together.": "یک حساب، همه بازی‌ها، بردها و تورنمنت هایتان را یک‌جا نگه می‌دارد.",
  "Username": "نام کاربری",
  "Email": "ایمیل",
  "Enter an email address, a mobile number, or both.": "ایمیل، شماره موبایل یا هر دو را وارد کنید.",
  "Enter an email address or a mobile number.": "ایمیل یا شماره موبایل را وارد کنید.",
  "Enter an email address.": "ایمیل را وارد کنید.",
  "Mobile numbers are not supported on this server.": "ثبت‌نام با شماره موبایل در این سرور پشتیبانی نمی‌شود.",
  "A user is already registered with this mobile number.": "کاربری با این شماره موبایل قبلاً ثبت‌نام کرده است.",
  "Enter a valid Iranian mobile number, e.g. 09121234567.": "یک شماره موبایل معتبر ایرانی وارد کنید؛ مثلاً ۰۹۱۲۱۲۳۴۵۶۷.",
  "This mobile number is already used by another account.": "این شماره موبایل برای حساب دیگری استفاده شده است.",
  "8+ characters": "حداقل ۸ کاراکتر",
  "Create a password": "یک رمز عبور بسازید",
  "Confirm password": "تکرار رمز عبور",
  "Repeat your password": "رمز عبور را دوباره وارد کنید",
  "Creating your profile...": "در حال ساخت پروفایل...",
  "Create my account": "ساخت حساب من",
  "Already have a profile?": "قبلاً ثبت‌نام کرده‌اید؟",
  "Sign in here": "از اینجا وارد شوید",

  // Game player
  "You have reached your active session limit. Please close another game tab or try again in a moment.": "به سقف نشست‌های هم‌زمان رسیده‌اید. لطفاً زبانه بازی دیگری را ببندید یا کمی بعد دوباره تلاش کنید.",
  "You do not have access to this game.": "به این بازی دسترسی ندارید.",
  "Could not create a game session. Please refresh the page and try again.": "ساخت نشست بازی ممکن نشد. لطفاً صفحه را تازه کنید و دوباره تلاش کنید.",
  "Free": "رایگان",
  "Too many games were started from your network. Please wait a few minutes and try again.": "از شبکه شما بازی‌های زیادی شروع شده است. لطفاً چند دقیقه صبر کنید و دوباره تلاش کنید.",
  "Requesting the game session took too long. Please try again.": "درخواست نشست بازی بیش از حد طول کشید. لطفاً دوباره تلاش کنید.",
  "Game access response is missing sessionId.": "پاسخ دسترسی به بازی شناسه نشست ندارد.",
  "Game player": "اجرای بازی",
  "Game ready — gameplay uses the separate game QR": "بازی آماده است؛ برای بازی از کد QR جداگانه بازی استفاده کنید",
  "Game needs attention": "بازی نیاز به بررسی دارد",
  "Loading game": "در حال بارگذاری بازی",
  "Game screen": "صفحه بازی",
  "Back to games": "بازگشت به بازی‌ها",
  "Retry game": "اجرای دوباره بازی",
  "Exit fullscreen": "خروج از تمام‌صفحه",
  "Request fullscreen": "درخواست تمام‌صفحه",
  "Music": "موسیقی",
  "Previous track": "آهنگ قبلی",
  "Next track": "آهنگ بعدی",
  "Pause music": "توقف موسیقی",
  "Play music": "پخش موسیقی",
  "Mute": "بی‌صدا",
  "Volume": "صدا",
  "Track": "آهنگ",
  "Tutorial": "آموزش",
  "Start playing": "شروع بازی",
  "Skip tutorial": "رد کردن آموزش",
  "Invalid game name.": "نام بازی نامعتبر است.",
  "Finding your game": "در حال پیدا کردن بازی",
  "Preparing a secure session": "در حال آماده‌سازی نشست امن",
  "Loading the arena": "در حال آماده‌سازی میدان",
  "We couldn't load this game's details.": "بارگذاری جزئیات این بازی ممکن نشد.",
  "You don't have access to this game.": "به این بازی دسترسی ندارید.",
  "Now playing": "در حال اجرا",
  "Your screen is the arena. Invite players and jump in.": "صفحه شما میدان بازی است. بازیکنان را دعوت کنید و شروع کنید.",
  "Game ready": "بازی آماده است",
  "Needs attention": "نیاز به بررسی",
  "Getting ready": "در حال آماده‌سازی",
  "Phone requested fullscreen": "گوشی درخواست تمام‌صفحه داد",
  "Browsers require one click on this screen.": "مرورگرها برای این کار یک کلیک روی همین صفحه لازم دارند.",
  "Enter": "ورود",
  "Enter fullscreen mode": "رفتن به حالت تمام‌صفحه",
  "Fullscreen": "تمام‌صفحه",
  "Exit fullscreen mode": "خروج از حالت تمام‌صفحه",
  "Join game": "ورود به بازی",
  "Scan with your phone to play": "برای بازی با گوشی اسکن کنید",
  "Game couldn't start": "بازی اجرا نشد",
  "Something interrupted the game while it was loading.": "هنگام بارگذاری بازی مشکلی پیش آمد.",
  "Try again": "تلاش دوباره",
  "The game is downloading. You can use the tutorial while you wait.": "بازی در حال دانلود است. تا آن موقع می‌توانید آموزش را ببینید.",
  "Game download progress": "پیشرفت دانلود بازی",
  "{{percent}}%": "{{percent}}٪",

  // Music player
  "Game music player": "پخش‌کننده موسیقی بازی",
  "Select play to start music": "برای پخش موسیقی، دکمه پخش را بزنید",
  "Unmute music": "باصدا کردن موسیقی",
  "Mute music": "بی‌صدا کردن موسیقی",
  "Music volume": "صدای موسیقی",
  "Search music by title, artist, or tag": "جست‌وجوی موسیقی بر اساس نام، خواننده یا برچسب",
  "Search by title, artist, or tag...": "جست‌وجو بر اساس نام، خواننده یا برچسب...",
  "Music search results": "نتایج جست‌وجوی موسیقی",
  "No matching music found.": "موسیقی‌ای پیدا نشد.",

  // Tournaments
  "Motion": "حرکتی",
  "Cumulative": "تجمعی",
  "Elimination": "حذفی",
  "Individual": "انفرادی",
  "Team": "تیمی",
  "Teams": "تیمی",
  "Team battle": "نبرد تیمی",
  "Solo competition": "رقابت انفرادی",
  "Round lineup": "ترتیب راندها",
  "No games selected": "بازی‌ای انتخاب نشده",
  "Preparing…": "در حال آماده‌سازی…",
  "Start tournament": "شروع مسابقه",
  "Edit {{name}}": "ویرایش {{name}}",
  "Edit tournament": "ویرایش مسابقه",
  "Your saved championships": "مسابقات ذخیره‌شده شما",
  "Search": "جست‌وجو",
  "Tournament or game": "مسابقه یا بازی",
  "Start selected": "شروع مورد انتخاب‌شده",
  "Edit selected": "ویرایش مورد انتخاب‌شده",
  "Build tournament": "ساخت مسابقه",
  "Tournament arena": "میدان مسابقه",
  "Your championships,": "مسابقات شما،",
  "ready when you are.": "هر وقت آماده باشید.",
  "Launch a saved tournament, bring players into one persistent lobby, and move through every game without reconnecting.": "یک تورنمنت ساخته شده را شروع کنید، بازیکنان را در یک لابی جمع کنید و بدون نیاز به اتصال دوباره از بازی‌ای به بازی دیگر بروید.",
  "Total rounds": "کل دورها",
  "Team events": "مسابقات تیمی",
  "Saved tournaments": "مسابقات ذخیره‌شده",
  "Pick a format and open its player lobby.": "یک قالب انتخاب کنید و لابی بازیکنان را باز کنید.",
  "Search tournaments or games": "جست‌وجوی مسابقه یا بازی",
  "No matching tournaments": "مسابقه‌ای پیدا نشد",
  "Try a tournament name, game title, or scoring mode.": "نام مسابقه، نام بازی یا نوع امتیازدهی را امتحان کنید.",
  "Clear search": "پاک کردن جست‌وجو",
  "Create your first championship": "اولین تورنمنت تان را بسازید",
  "Choose games, arrange the rounds, and select how players compete and score.": "بازی‌ها را انتخاب کنید، راندها را مرتب کنید و نحوه رقابت و امتیازدهی را تعیین کنید.",
  "{{count}} rounds selected": "{{count}} دور انتخاب شده",
  "Name": "نام",
  "Friday Night Championship": "مسابقه جمعه‌شب",
  "Title, tag or genre": "نام، برچسب یا ژانر",
  "Remove game": "حذف بازی",
  "Add game": "افزودن بازی",
  "Move round up": "انتقال دور به بالا",
  "Move round down": "انتقال دور به پایین",
  "Rules": "قوانین",
  "Scoring": "امتیازدهی",
  "Motion tournament": "مسابقه حرکتی",
  "Save changes": "ذخیره تغییرات",
  "Create tournament": "ساخت مسابقه",
  "Tournament studio": "استودیوی مسابقه",
  "Refine your tournament": "تورنمنت‌تان را کامل کنید",
  "Build your tournament": "تورنمنت‌تان را بسازید",
  "Choose from your playable games, arrange the rounds, and decide how the winner is crowned.": "از بازی‌های در دسترس‌تان انتخاب کنید، راندها را مرتب کنید و تعیین کنید قهرمان چطور مشخص شود.",
  "Rounds selected": "راندهای انتخاب‌شده",
  "Tournament name": "نام تورنمنت",
  "Choose games": "انتخاب بازی‌ها",
  "Only games available in your account are shown.": "فقط بازی‌های موجود در حساب شما نمایش داده می‌شوند.",
  "Search title, tag or genre": "جست‌وجوی نام، برچسب یا ژانر",
  "{{min}}–{{max}} players": "{{min}} تا {{max}} بازیکن",
  "No playable games found": "بازی قابل اجرایی پیدا نشد",
  "Try another search or switch the motion-game filter.": "جست‌وجوی دیگری انجام دهید یا فیلتر بازی حرکتی را تغییر دهید.",
  "Loading your games…": "در حال بارگذاری بازی‌ها…",
  "Play order": "ترتیب بازی",
  "First game starts at the top.": "بازی اول، بالای فهرست است.",
  "Move {{title}} up": "انتقال {{title}} به بالا",
  "Move {{title}} down": "انتقال {{title}} به پایین",
  "Select games to build the round order.": "برای ساختن ترتیب راندها بازی انتخاب کنید.",
  "Tournament rules": "قوانین تورنمنت",
  "Every round contributes to the final total.": "امتیاز همه راندها در نتیجه نهایی جمع می‌شود.",
  "The lowest scorer leaves after each round.": "کم‌امتیازترین بازیکن بعد از هر راند حذف می‌شود.",
  "Every player competes for their own score.": "هر بازیکن برای امتیاز خودش رقابت می‌کند.",
  "Players choose one of ten color teams.": "بازیکنان یکی از ده تیم رنگی را انتخاب می‌کنند.",
  "Use camera-based games with up to four players per device.": "بازی‌های مبتنی بر دوربین با حداکثر چهار بازیکن برای هر دستگاه.",
  "Saving…": "در حال ذخیره…",
  "{{count}} players in lobby": "{{count}} بازیکن در لابی",
  "Tournament finished": "تورنمنت تمام شد",
  "Preparing round": "در حال آماده‌سازی راند",
  "Begin tournament": "شروع تورنمنت",
  "Recovery device": "دستگاه بازیابی",
  "Device {{number}}": "دستگاه {{number}}",
  "Show recovery code": "نمایش کد بازیابی",
  "Back to tournaments": "بازگشت به تورنمنت‌ها",
  "Loading tournament…": "در حال بارگذاری تورنمنت…",
  "{{name}} lobby": "لابی {{name}}",
  "Scan once for the whole tournament": "یک‌بار برای کل تورنمنت اسکن کنید",
  "Open tournament controller": "باز کردن کنترلر تورنمنت",
  "Players ({{count}})": "بازیکنان ({{count}})",
  "New recovery code": "کد بازیابی جدید",
  "Starting in {{seconds}}": "شروع تا {{seconds}} ثانیه دیگر",
  "Reconnect device": "اتصال دوباره دستگاه",
  "Code": "کد",
  "red": "قرمز",
  "blue": "آبی",
  "green": "سبز",
  "yellow": "زرد",
  "orange": "نارنجی",
  "purple": "بنفش",
  "pink": "صورتی",
  "cyan": "فیروزه‌ای",
  "lime": "لیمویی",
  "brown": "قهوه‌ای",

  // Phone remote
  "Connect phone remote": "اتصال ریموت موبایل",
  "Remote connected": "ریموت متصل است",
  "Phone remote": "ریموت موبایل",
  "A phone is connected": "یک گوشی متصل است",
  "Waiting for the paired phone": "در انتظار گوشی جفت‌شده",
  "The QR is hidden and no second controller can join.": "کد QR پنهان شده و کنترلر دیگری نمی‌تواند وصل شود.",
  "Reconnecting…": "در حال اتصال دوباره…",
  "Preparing secure pairing…": "در حال آماده‌سازی اتصال امن…",
  "Scan with the phone that will control this screen.": "با گوشی‌ای که قرار است این صفحه را کنترل کند اسکن کنید.",
  "The pairing code expired.": "کد اتصال منقضی شد.",
  "Generate new QR": "ساخت QR جدید",
  "Pair another phone": "اتصال گوشی دیگر",
  "New QR": "QR جدید",
  "End remote": "پایان ریموت",
  "Navigate": "جابه‌جایی",
  "Page": "صفحه",
  "Back": "بازگشت",
  "Scroll up": "بالا رفتن",
  "Scroll down": "پایین رفتن",
  "Top": "ابتدای صفحه",
  "Bottom": "انتهای صفحه",
  "Hard refresh website": "بارگذاری کامل دوباره سایت",
  "Website controls": "کنترل‌های سایت",
  "The website changed. Controls were refreshed.": "سایت تغییر کرد. کنترل‌ها به‌روز شدند.",
  "That control is not available now.": "این کنترل الان در دسترس نیست.",
  "The action failed.": "انجام این کار ممکن نشد.",
  "Could not connect to the remote-control service.": "اتصال به سرویس ریموت ممکن نشد.",
  "Remote reconnection failed.": "اتصال دوباره ریموت ممکن نشد.",
  "Could not create a remote session.": "ساخت نشست ریموت ممکن نشد.",
  "Could not reset pairing.": "بازنشانی اتصال ممکن نشد.",
  "Apply": "اعمال",
  "Done": "انجام شد",
  "Action failed": "انجام نشد",
  "This phone was disconnected by the main screen.": "این گوشی از طرف صفحه اصلی قطع شد.",
  "The remote session ended.": "نشست ریموت تمام شد.",
  "Could not reconnect.": "اتصال دوباره ممکن نشد.",
  "Scan a Pocket Play remote QR code to connect.": "برای اتصال، کد QR ریموت پاکت پلی را اسکن کنید.",
  "Pairing failed.": "اتصال ناموفق بود.",
  "Sending…": "در حال ارسال…",
  "Page {{page}} of {{total}}": "صفحه {{page}} از {{total}}",
  "Pocket Play remote": "ریموت پاکت پلی",
  "Connecting…": "در حال اتصال…",
  "Remote control sections": "بخش‌های ریموت",
  "Go to {{section}} controls": "رفتن به کنترل‌های {{section}}",
  "Remote unavailable": "ریموت در دسترس نیست",
  "Show a new QR code on the main screen to pair again.": "برای اتصال دوباره، یک کد QR جدید روی صفحه اصلی نمایش دهید.",
  "Reconnecting to the screen…": "در حال اتصال دوباره به صفحه…",
  "Waiting for website controls…": "در انتظار کنترل‌های سایت…",
  "Waiting for the main screen to reconnect…": "در انتظار اتصال دوباره صفحه اصلی…",
  "Current selection": "انتخاب فعلی",
  "Previous section": "بخش قبلی",
  "Next section": "بخش بعدی",
  // Save & continue
  "Continue a saved game": "ادامه بازی ذخیره‌شده",
  "Pick up where you left off, or start a new game.": "از همان جایی که ماندید ادامه دهید، یا بازی تازه‌ای شروع کنید.",
  "Autosave": "ذخیره خودکار",
  "Saved": "ذخیره‌شده",
  "Saved game": "بازی ذخیره‌شده",
  "Continue": "ادامه",
  "Really delete?": "واقعاً حذف شود؟",
  "Delete": "حذف",
  "Start a new game": "شروع بازی جدید",
  "Game saved": "بازی ذخیره شد",
  "Could not save the game": "ذخیره بازی انجام نشد",
  "The game could not load this save.": "بازی نتوانست این ذخیره را بارگذاری کند.",
  "The game did not respond. Try again.": "بازی پاسخ نداد. دوباره تلاش کنید.",
  "Could not load this save. Try again.": "بارگذاری این ذخیره انجام نشد. دوباره تلاش کنید.",
  "Saved games": "بازی‌های ذخیره‌شده",
  // Referrals
  "Invite & Earn": "دعوت کن و هدیه بگیر",
  "Refer friends and earn free subscription days.": "دوستانت را دعوت کن و روزهای رایگان اشتراک بگیر.",
  "Loading referrals...": "در حال بارگذاری دعوت‌ها...",
  "Could not load your referrals.": "بارگذاری دعوت‌های شما انجام نشد.",
  "Friends get {{percent}}% off their first Gold or Venue subscription. When they pay, you get free days on your own {{tier}} plan.": "دوستانت روی اولین اشتراک طلایی یا ونیو {{percent}}٪ تخفیف می‌گیرند. وقتی پرداخت کنند، روزهای رایگان به پلن {{tier}} خودت اضافه می‌شود.",
  "Gold": "طلایی",
  "Venue": "ونیو",
  "Copy": "کپی",
  "Copied": "کپی شد",
  "Creating...": "در حال ساخت...",
  "Get my invite code": "دریافت کد دعوت",
  "Could not create your invite code.": "ساخت کد دعوت انجام نشد.",
  "Your invite code": "کد دعوت شما",
  "Invitation link": "لینک دعوت",
  "Your reward per friend": "هدیه شما برای هر دوست",
  "{{plan}} {{interval}}": "{{plan}} {{interval}}",
  "+{{days}} {{tier}} days": "+{{days}} روز {{tier}}",
  "Successful referrals": "دعوت‌های موفق",
  "Bonus days earned": "روزهای هدیه دریافتی",
  "Next milestone": "مرحله بعدی",
  "Progress to the next reward": "پیشرفت تا هدیه بعدی",
  "Invite 1 more friend and earn {{days}} extra {{tier}} days!": "۱ دوست دیگر دعوت کن و {{days}} روز {{tier}} اضافه بگیر!",
  "Invite {{count}} more friends and earn {{days}} extra {{tier}} days!": "{{count}} دوست دیگر دعوت کن و {{days}} روز {{tier}} اضافه بگیر!",
  "Current milestone: {{count}} referrals": "مرحله فعلی: {{count}} دعوت",
  "You have reached every milestone. Keep inviting friends to earn more days!": "به همه مراحل رسیده‌ای. با دعوت دوستان باز هم روز رایگان بگیر!",
  "Reward history": "تاریخچه هدیه‌ها",
  "{{count}}-referral milestone": "مرحله {{count}} دعوت",
  "A friend bought {{plan}} ({{interval}})": "یک دوست {{plan}} ({{interval}}) خرید",
  "Pending": "در انتظار",
  "No rewards yet. Share your invite link to get started.": "هنوز هدیه‌ای ندارید. لینک دعوت خود را به اشتراک بگذارید.",
  "Verify your email address or mobile number to get your invite code.": "برای دریافت کد دعوت، ایمیل یا شماره موبایل خود را تأیید کنید.",
  "Send verification email": "ارسال ایمیل تأیید",
  "Check your inbox for a verification link.": "لینک تأیید را در صندوق ایمیل خود ببینید.",
  "Could not send the verification email.": "ارسال ایمیل تأیید انجام نشد.",
  "Send code": "ارسال کد",
  "Send a new code": "ارسال کد جدید",
  "Could not send the code.": "ارسال کد انجام نشد.",
  "Verification code": "کد تأیید",
  "Verify": "تأیید",
  "Could not verify the code.": "تأیید کد انجام نشد.",
  "Add an email address or mobile number to your account first.": "ابتدا یک ایمیل یا شماره موبایل به حساب خود اضافه کنید.",
  "Have an invite code? Enter it for a discount on your first Gold or Venue subscription.": "کد دعوت دارید؟ آن را وارد کنید تا روی اولین اشتراک طلایی یا ونیو تخفیف بگیرید.",
  "Referral code (optional)": "کد دعوت (اختیاری)",
  "Invite code {{code}} is saved and will be applied to your first Gold or Venue subscription.": "کد دعوت {{code}} ذخیره شد و روی اولین اشتراک طلایی یا ونیو شما اعمال می‌شود.",
  "Remove": "حذف",
  "Email verification": "تأیید ایمیل",
  "Your email address is verified.": "ایمیل شما تأیید شد.",
  "This verification link is invalid or has expired.": "این لینک تأیید نامعتبر است یا منقضی شده است.",
  "Verifying your email address...": "در حال تأیید ایمیل شما...",
  "Go to your account": "رفتن به حساب کاربری",

  // Checkout, verification, and server messages
  "I have read and agree to the {{terms}}.": "{{terms}} را خوانده‌ام و می‌پذیرم.",
  "Terms and Conditions": "قوانین و مقررات",
  "Renewal reminders are sent to {{mobile}}.": "یادآور تمدید به شماره {{mobile}} فرستاده می‌شود.",
  "Available after your plan ends": "پس از پایان پلن فعلی",
  "Payment successful": "پرداخت موفق",
  "Payment not completed": "پرداخت انجام نشد",
  "Your subscription is active. Enjoy the games!": "اشتراک شما فعال شد. از بازی‌ها لذت ببرید!",
  "Your pass is active. Enjoy the games!": "پاس شما فعال شد. از بازی‌ها لذت ببرید!",
  "The game is now in your library.": "این بازی به کتابخانه شما اضافه شد.",
  "It can take a few seconds for your purchase to appear.": "ممکن است چند ثانیه طول بکشد تا خرید شما نمایش داده شود.",
  "Tracking code": "کد پیگیری",
  "Taking you to the games in {{count}} seconds...": "تا {{count}} ثانیه دیگر به صفحه بازی‌ها منتقل می‌شوید...",
  "Taking you to your account in {{count}} seconds...": "تا {{count}} ثانیه دیگر به حساب کاربری منتقل می‌شوید...",
  "Go to games": "رفتن به بازی‌ها",
  "Contact us": "تماس با ما",
  "The payment was cancelled or not approved by the bank. If money was taken from your card, the bank returns it automatically.": "پرداخت لغو شد یا از سوی بانک تأیید نشد. اگر مبلغی از کارت شما کسر شده باشد، بانک آن را به‌طور خودکار بازمی‌گرداند.",
  "We could not confirm your payment with the bank. If money was taken from your card, your purchase is completed automatically within a few minutes; otherwise the bank returns the money.": "تأیید پرداخت از بانک ممکن نشد. اگر مبلغی از کارت شما کسر شده باشد، خرید شما ظرف چند دقیقه به‌طور خودکار تکمیل می‌شود؛ در غیر این صورت بانک مبلغ را بازمی‌گرداند.",
  "This payment could not be completed.": "این پرداخت انجام نشد.",
  "We could not find this payment.": "این پرداخت پیدا نشد.",
  "Need help? Contact us and mention the time of your payment.": "به کمک نیاز دارید؟ با ما تماس بگیرید و زمان پرداخت را اعلام کنید.",
  "Could not reach the server. Check your connection and try again.": "ارتباط با سرور برقرار نشد. اتصال اینترنت را بررسی کنید و دوباره تلاش کنید.",
  "The payment service is not responding. Please try again in a few minutes.": "سرویس پرداخت پاسخ نمی‌دهد. لطفاً چند دقیقه دیگر دوباره تلاش کنید.",
  "Verify your account": "تأیید حساب کاربری",
  "Enter verification details on the main screen": "اطلاعات تأیید را روی صفحه اصلی وارد کنید",
  "Sign in to verify your account.": "برای تأیید حساب کاربری وارد شوید.",
  "Verify your email address or mobile number. You need a verified account to make payments.": "ایمیل یا شماره موبایل خود را تأیید کنید. برای پرداخت، حساب کاربری شما باید تأیید شده باشد.",
  "Your account is verified.": "حساب کاربری شما تأیید شد.",
  "Skip for now": "بعداً انجام می‌دهم",
  "Verified": "تأیید شده",
  "Verify your email address or mobile number to make payments.": "برای پرداخت، ایمیل یا شماره موبایل خود را تأیید کنید.",
  "Verify now": "تأیید حساب",
  "Verify your email address or mobile number before paying.": "پیش از پرداخت، ایمیل یا شماره موبایل خود را تأیید کنید.",
  "A mobile number is required for payment.": "برای پرداخت، شماره موبایل لازم است.",
  "This item is not priced in Iranian Rial (IRR).": "قیمت این مورد به ریال تعیین نشده است.",
  "Invalid or expired discount code.": "کد تخفیف نامعتبر است یا منقضی شده است.",
  "You already have an active subscription. Renew it from your account page.": "شما اشتراک فعال دارید. آن را از صفحه حساب کاربری تمدید کنید.",
  "Your subscription already includes full access.": "اشتراک شما همین حالا دسترسی کامل دارد.",
  "Your new plan is already paid and starts when your pass ends.": "هزینه پلن جدید شما پرداخت شده و پس از پایان پاس فعلی شروع می‌شود.",
  "You already have access to this game.": "شما به این بازی دسترسی دارید.",
  "You do not have an active subscription.": "اشتراک فعالی ندارید.",
  "A pass does not renew. Choose a plan to subscribe when you are ready.": "پاس تمدید نمی‌شود. هر وقت آماده بودید یک پلن اشتراک انتخاب کنید.",
  "You can't use your own referral code.": "نمی‌توانید از کد دعوت خودتان استفاده کنید.",
  "Referral codes apply only to Gold or Venue subscriptions.": "کد دعوت فقط برای اشتراک طلایی یا ونیو قابل استفاده است.",
  "You have already used a referral code.": "شما قبلاً از کد دعوت استفاده کرده‌اید.",
  "Referral codes are only for your first Gold or Venue subscription.": "کد دعوت فقط برای اولین اشتراک طلایی یا ونیو است.",
  "Please wait a minute before requesting another code.": "لطفاً یک دقیقه صبر کنید و بعد کد جدید درخواست کنید.",
  "Add a mobile number to your account first.": "ابتدا یک شماره موبایل به حساب خود اضافه کنید.",
  "Your mobile number is already verified.": "شماره موبایل شما قبلاً تأیید شده است.",
  "The code is incorrect.": "کد وارد شده اشتباه است.",
  "This code has expired. Request a new one.": "این کد منقضی شده است. کد جدید درخواست کنید.",
  "Too many attempts. Request a new code.": "تعداد تلاش‌ها زیاد بود. کد جدید درخواست کنید.",
  "Request a verification code first.": "ابتدا کد تأیید را درخواست کنید.",
  "The code could not be sent. Try again later.": "ارسال کد انجام نشد. بعداً دوباره تلاش کنید.",
  "Phone verification is not available on this server.": "تأیید شماره موبایل در این سرور در دسترس نیست.",
  "Email delivery is not available during the beta.": "ارسال ایمیل در دوره آزمایشی در دسترس نیست.",
  "Too many codes were requested. Try again later.": "تعداد درخواست‌های کد زیاد بود. کمی بعد دوباره تلاش کنید.",
  "Enter a new password.": "رمز عبور جدید را وارد کنید.",
  "The two passwords do not match.": "رمزهای عبور یکسان نیستند.",
  "This password is too short. It must contain at least 8 characters.": "این رمز عبور خیلی کوتاه است. باید دست‌کم ۸ کاراکتر داشته باشد.",
  "This password is too common.": "این رمز عبور بیش از حد رایج است.",
  "This password is entirely numeric.": "رمز عبور نباید فقط از عدد تشکیل شده باشد.",
  "The password is too similar to the username.": "رمز عبور بیش از حد به نام کاربری شبیه است.",

  // Sign-in with an SMS code and password reset
  "Forgot your password?": "رمز عبور را فراموش کرده‌اید؟",
  "Sign in with an SMS code instead": "ورود با کد پیامکی",
  "Sign in with your password instead": "ورود با رمز عبور",
  "Text me a code": "ارسال کد پیامکی",
  "Sending code...": "در حال ارسال کد...",
  "Change number": "تغییر شماره",
  "If an account uses this number, we texted it a sign-in code.": "اگر حسابی با این شماره ثبت شده باشد، کد ورود برای آن پیامک شد.",
  "If an account uses this number, we texted it a reset code.": "اگر حسابی با این شماره ثبت شده باشد، کد بازیابی برای آن پیامک شد.",
  "Account recovery": "بازیابی حساب",
  "Locked out? Let's get you back in.": "رمز را فراموش کرده‌اید؟ برگردید به بازی.",
  "We text a code to the mobile number on your account. Enter it with a new password and you're back in the game.": "کدی به شماره موبایل حساب شما پیامک می‌کنیم. آن را همراه رمز عبور جدید وارد کنید و دوباره وارد بازی شوید.",
  "Recovery code ready": "کد بازیابی آماده است",
  "Reset your password": "بازیابی رمز عبور",
  "Enter the mobile number on your account and we'll text you a code.": "شماره موبایل حساب خود را وارد کنید تا کدی برایتان پیامک کنیم.",
  "Password reset is not available on this server yet. Contact us and we'll help you get back in.": "بازیابی رمز عبور در این سرور هنوز در دسترس نیست. با ما تماس بگیرید تا به حساب خود برگردید.",
  "New password": "رمز عبور جدید",
  "Confirm new password": "تکرار رمز عبور جدید",
  "Set new password": "ثبت رمز عبور جدید",
  "Could not reset your password.": "بازیابی رمز عبور انجام نشد.",
  "Remembered it?": "رمز را به یاد آوردید؟",
  "Back to sign in": "بازگشت به ورود",
};

export default fa;
